import React, { useState } from "react";
import { Box, Button, Flex, Image, Text } from "@chakra-ui/react";
import iconExcel from "../../assets/images/employee/iconExcel.svg";
import TableSeriveFee from "./tableServiceFee";
import toast from "react-hot-toast";
import { exportFile } from "../../utils/tools";
import { useServiceFee } from "../../hooks/useServiceFee";
import { serviceFeeCall } from "../../api/serviceFee";
export default function ServiceFee() {
  const { entries, serviceFeeData, isRefetching } = useServiceFee();
  const [paramExport, setParamExport] = useState(null);

  const handleExport = async () => {
    const columnMapping = {
      time: "Thời gian",
      code: "Mã NV",
      fullName: "Tên nhân viên",
      jobTitle: "Chức vụ",
      phone: "Số điện thoại",
      saleBlock: "Khối",
      saleArea: "Vùng",
      serviceFee: "Tổng PDV",
    };
    if (serviceFeeData?.length) {
      const data = await serviceFeeCall.export(entries, paramExport);
      if (data) {
        exportFile(data, columnMapping, "danh_sach_hoa_hong_cua_nhan_vien.xlsx");
        toast.success("Download file thành công");
      } else {
        toast.error("Không có dữ liệu");
      }
    } else toast.error("Không có dữ liệu");
  };

  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems={"center"} gap={{ base: "74px" }}>
          <Text fontSize={{ base: "20px" }} fontWeight={600}>
            Phí dịch vụ
          </Text>
        </Flex>
        <Flex alignItems={"center"} gap={"16px"}>
          <Button
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            h={"44px"}
            backgroundImage="var(--linear-gradient-excel)"
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={handleExport}
          >
            <Image src={iconExcel} />
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Xuất excel
            </Text>
          </Button>
        </Flex>
      </Flex>
      <Box mt={{ base: "23px" }}>
        <TableSeriveFee 
          isRefetchingWithCreate={isRefetching} 
          paramData={setParamExport}
        />
      </Box>
    </Box>
  );
}
